import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-view-slider",
  templateUrl: "./med-icon-view-slider.component.html",
})
export class MedIconViewSliderComponent extends SvgMixinComponent {}
